import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";

const ArchivePageModal = ({ open = false, onClose = () => {}, onConfirm = () => {} }) => {
  return (
    <Modal
      show={open}
      onHide={onClose}
      closeOnEscape={false}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[620px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header
        title="Archive Page"
        description={
          <div className="tw-flex tw-flex-col tw-gap-[24px] tw-text-gray-50">
            <span>
              The page will no longer appear on any Brivity websites. You will be able to edit and publish the
              page in the future if you wish.
            </span>
            <span>Are you sure you want to archive this page?</span>
          </div>
        }
        closeButton
      />
      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[8px]">
        <Button schema="tertiary" size="medium" onClick={onClose}>
          Cancel
        </Button>
        <Button size="medium" schema="warning" onClick={onConfirm}>
          Yes, Archive
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ArchivePageModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ArchivePageModal;
